module.exports = __webpack_public_path__ + "img/tpc-27.7e21f39b.jpg";